module.exports = __webpack_public_path__ + "images/slv_sturm.png?0fab764f760cfc33ff54f974fe4fb6cd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slv_sturm.png
// module id = F33k
// module chunks = 0